"use strict";

var _qrSvg = require("./components/qr-svg");

module.exports = { QRCode: _qrSvg.QRCode };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-qr-svg/dist-modules/index.js
// module id = 1499
// module chunks = 0